
import CardPage1 from "../../components/page1-com/cardpage1";
import Title from "../../components/page1-com/title";

export default function Page1(){
    
    return(
        <>
        <Title/>
        <CardPage1/>
        </>
    )
}